module.exports = __webpack_public_path__ + "static/img/about.02bc971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/about.jpg
// module id = k+b/
// module chunks = 11